module.exports = __webpack_public_path__ + "assets/img/HY.44440ea8.png";